import { render, staticRenderFns } from "./ProductsListItem.vue?vue&type=template&id=47fe9b42&scoped=true"
import script from "./ProductsListItem.vue?vue&type=script&lang=js"
export * from "./ProductsListItem.vue?vue&type=script&lang=js"
import style0 from "./ProductsListItem.vue?vue&type=style&index=0&id=47fe9b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe9b42",
  null
  
)

export default component.exports